import {
  Routes,
  Route,
  Navigate,
  RouteProps,
  RoutesProps,
} from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import { useState } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main"; 

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Login = React.lazy(() => import("../components/Login/Login"));

  const Dashboard = React.lazy(
    () => import("../components/Dashboard/Dashboard")
  );

  const Booking_Details = React.lazy(
    () => import("../components/Booking_Details/Booking_Details")
  );

  const Otp = React.lazy(() => import("../components/Otp/Otp"));

  const Payment = React.lazy(() => import("../components/Payment/Payment"));



  const Charging = React.lazy(() => import("../components/Charging/Charging"));
  
  // INSTANT BOOKING (23/09/2026): connect the gun first, pay after.
  const InstantBooking = React.lazy(
    () => import("../components/InstantBooking/InstantBooking")
  );
  const PrivacyPolicy = React.lazy(
    () => import("../components/Privacy Policy/privacy-policy")
  );
  const Charging_start = React.lazy(
    () => import("../components/Charging_start/Charging_start")
  );
  
  const Booking_Complete = React.lazy(
    () => import("../components/Booking_Complete/Booking_Complete")
  );
  
  const Feedback = React.lazy(
    () => import("../components/Feedback/Feedback")
  );
  const TermsCondition = React.lazy(
    () => import("../components/TermsCondition/TermsCondition")
  );
  const StationListPage = React.lazy(
    () => import("../components/StationList/StationList")
  );
  const InvoicePage = React.lazy(
    () => import("../components/InvoicePage/InvoicePage")
  );
  const HomePage = React.lazy(
    () => import("../components/HomePage/Home")
  );

  return (
    <>
      <div id="main-wraper">
        <Routes>
        <Route path="/TermCondition" element={<Suspense fallback={<></>}> <TermsCondition /> </Suspense>}/>
        <Route path="/PrivacyPolicy" element={<Suspense fallback={<></>}> <PrivacyPolicy /> </Suspense>}/>
        <Route path="/StationList" element={<Suspense fallback={<></>}> <StationListPage /> </Suspense>}/>
        <Route path="/homePage" element={<Suspense fallback={<></>}> <HomePage /> </Suspense>}/>
        <Route path="/Invoice-Download" element={<Suspense fallback={<></>}> <InvoicePage /> </Suspense>}/>
        <Route path="/privacy-policy" element={<Suspense fallback={<></>}> <PrivacyPolicy /> </Suspense>}/>
         

          <Route path="/login" element={<Suspense fallback={<></>}> <Login /> </Suspense>}/>
          <Route path="/" element={<Navigate replace to="/homePage" />} />
          <Route path="/"
            element={ <ProtectedRoute isAuthenticated={true} {...defaultProtectedRouteProps} outlet={<Main />} />} >
            <Route path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  <Dashboard />
                </Suspense>
              }
            />
            <Route path="/instant"
              element={
                <Suspense fallback={<></>}>
                  <InstantBooking />
                </Suspense>
              }
            />
            <Route  path="/bookingdetails"
              element={
                <Suspense fallback={<></>}>
                  <Booking_Details />
                </Suspense>
              }
            />
            <Route
              path="/otp"
              element={
                <Suspense fallback={<></>}>
                  <Otp />
                </Suspense>
              }
            />
            <Route
              path="/payment"
              element={
                <Suspense fallback={<></>}>
                  <Payment />
                </Suspense>
              }
            />

            <Route
              path="/charging"
              element={
                <Suspense fallback={<></>}>
                  <Charging />
                </Suspense>
              }
            />
        
            <Route
              path="/chargingstart"
              element={
                <Suspense fallback={<></>}>
                  <Charging_start />
                </Suspense>
              }
            />
            <Route
              path="/bookingcomplete"
              element={
                <Suspense fallback={<></>}>
                  <Booking_Complete />
                </Suspense>
              }
            />
              <Route
              path="/feedback"
              element={
                <Suspense fallback={<></>}>
                  <Feedback />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
